import React from 'react';
import {  Routes, Route, HashRouter } from 'react-router-dom';
import Home from './User/View/home';
import Logout from './User/View/logout';
import Navbar from './User/View/mudole/navbar';
import Login from './User/View/login';
import Cart from './User/View/cart';
import Product from './User/View/product';
import ProductList from './User/View/productList';
import ProductDetails from './User/View/productDetails';
import Manage from './Admin/View/manage';
import ProductManage from './Admin/View/productManage';
import Product1 from './User/View/product1';
import Product2 from './User/View/product2';
import Foot from './User/View/foot';
import LeafParticles from './User/View/LeafParticles';
import Chat from './User/View/chat';

const App = () => {
  return (
    <>
      <HashRouter>
        <Routes>
          <Route index element={<Home/>} ></Route>
          <Route path="Logout" element={<Logout />} /> 
          <Route path="Navbar" element={<Navbar />} /> 
          <Route path="Login" element={<Login />} /> 
          <Route path="Cart" element={<Cart />} />
          <Route path="Product" element={<Product />} />
          <Route path="Product1" element={<Product1 />} />
          <Route path="Product2" element={<Product2 />} />
          <Route path="ProductList" element={<ProductList />} />
          <Route path="ProductDetails/:id" element={<ProductDetails />} />
          <Route path="Manage" element={<Manage />} />
          <Route path="Foot" element={<Foot />} />
          <Route path="ProductManage" element={<ProductManage />} />
          <Route path="LeafParticles" element={<LeafParticles />} />
          <Route path="Chat" element={<Chat />} />
        </Routes> 
      </HashRouter>
    </>
  );
}

export default App;
